module.exports = __webpack_public_path__ + "static/media/1.6513e5e6.jpg";